export default __webpack_public_path__ + "static/media/accessories-5.5c2fad2a.jpg";